export const AUTHENTICATE = 'AUTH/AUTHENTICATE';
export const SET_AUTHENTICATION_STATUS = 'AUTH/SET_AUTHENTICATION_STATUS';
export const LOG_OUT = 'AUTH/LOG_OUT';
export const SET_AUTHENTICATION_REDIRECT_URL = 'AUTH/SET_AUTHENTICATION_REDIRECT_URL';
export const AUTHENTICATE_BY_CWT_TOKEN = 'AUTH/AUTHENTICATE_BY_CWT_TOKEN';

export const SIGN_IN = 'AUTH/SIGN_IN';
export const SIGN_IN_REQUEST = 'AUTH/SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'AUTH/SIGN_IN_SUCCESS';
export const SIGN_IN_ERROR = 'AUTH/SIGN_IN_ERROR';

export const SET_AUTH_TOKEN_ACCESS = 'AUTH/SET_AUTH_TOKEN_ACCESS';
export const SET_AUTH_TOKEN_WELLFUNNEL = 'AUTH/SET_AUTH_TOKEN_WELLFUNNEL';
export const SET_AUTH_TOKEN_REFRESH = 'AUTH/SET_AUTH_TOKEN_REFRESH';

export const SEND_TEMPORARY_PASSWORD = 'AUTH/SEND_TEMPORARY_PASSWORD';
export const SEND_TEMPORARY_PASSWORD_REQUEST = 'AUTH/SEND_TEMPORARY_PASSWORD_REQUEST';
export const SEND_TEMPORARY_PASSWORD_SUCCESS = 'AUTH/SEND_TEMPORARY_PASSWORD_SUCCESS';
export const SEND_TEMPORARY_PASSWORD_ERROR = 'AUTH/SEND_TEMPORARY_PASSWORD_ERROR';

export const GET_APP_ACCESS_CODE = 'AUTH/GET_APP_ACCESS_CODE';
export const GET_APP_ACCESS_CODE_REQUEST = 'AUTH/GET_APP_ACCESS_CODE_REQUEST';
export const GET_APP_ACCESS_CODE_SUCCESS = 'AUTH/GET_APP_ACCESS_CODE_SUCCESS';
export const GET_APP_ACCESS_CODE_FAILURE = 'AUTH/GET_APP_ACCESS_CODE_ERROR';

export const GET_AUTH_TOKEN = 'AUTH/GET_AUTH_TOKEN';
export const GET_AUTH_TOKEN_REQUEST = 'AUTH/GET_AUTH_TOKEN_REQUEST';
export const GET_AUTH_TOKEN_SUCCESS = 'AUTH/GET_AUTH_TOKEN_SUCCESS';
export const GET_AUTH_TOKEN_ERROR = 'AUTH/GET_AUTH_TOKEN_ERROR';
